import React, { useState } from "react";
import { useSelector } from "react-redux";

import { fechahora } from "../../../../services/utils";
import { db } from "../../../../firebase/firebasejs";
import FormRender from "../../../Fields/FormRender";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function AddUserMultipleEvents() {
  const userID = useSelector((state) => state.atlete.userID);

  const [procesando, setProcesando] = useState(false);
  const [progreso, setProgreso] = useState([]);

  const agregarMensaje = (mensaje) => {
    setProgreso((prev) => [...prev, mensaje]);
  };

  const sendFormMultipleEvents = async (data, eventosIds) => {
    const delay = (ms) =>
      new Promise((resolve) => setTimeout(resolve, ms));

    setProcesando(true);
    setProgreso([]);

    for (let i = 0; i < eventosIds.length; i++) {
      let eventoIndex = eventosIds[i];

      if (!String(eventoIndex).startsWith("evento_")) {
        eventoIndex = "evento_" + eventoIndex;
      }

      const eventoIdVisible = String(eventoIndex).replace("evento_", "");

      agregarMensaje(
        `Procesando acceso al evento ${eventoIdVisible}...`
      );

      try {
        const datosAutorizado = {
          correo: data.correo.toLowerCase().trim(),
          perfil: data.perfil,
          fechaAutoriza: fechahora(),
          userIdAuth: userID,
          status: "",
        };

        const newPostKey = db
          .ref()
          .child(
            `/eventosCompletos/${eventoIndex}/autorizacionOrganizador/`
          )
          .push().key;

        const statusRef = db.ref(
          `/eventosCompletos/${eventoIndex}/autorizacionOrganizador/${newPostKey}/status/`
        );

        const statusListener = statusRef.on(
          "value",
          function (snapshot) {
            const status = snapshot.val();

            if (status === "ok") {
              console.log(
                `Acceso autorizado correctamente al evento ${eventoIndex}`
              );

              statusRef.off("value", statusListener);
            } else if (status === "" || status === null) {
              // Esperando respuesta
            } else {
              console.log(
                `Respuesta evento ${eventoIndex}:`,
                status
              );

              statusRef.off("value", statusListener);
            }
          }
        );

        const updates = {};

        updates[
          `/eventosCompletos/${eventoIndex}/autorizacionOrganizador/${newPostKey}/`
        ] = datosAutorizado;

        await db.ref().update(updates);

        agregarMensaje(
          `✓ Acceso al evento ${eventoIdVisible} listo`
        );

        if (i < eventosIds.length - 1) {
          await delay(500);
        }
      } catch (error) {
        console.error(
          `Error autorizando evento ${eventoIndex}:`,
          error
        );

        agregarMensaje(
          `✕ Error al dar acceso al evento ${eventoIdVisible}`
        );
      }
    }

    agregarMensaje(
      `Proceso terminado. ${eventosIds.length} eventos procesados.`
    );

    setProcesando(false);
  };

  const sendForm = async (data) => {
    const eventosIds = String(data.eventosIds || "")
      .split(",")
      .map((id) => id.trim())
      .filter((id) => id !== "");

    if (eventosIds.length === 0) {
      setProgreso(["No se proporcionaron IDs de eventos"]);
      return;
    }

    await sendFormMultipleEvents(data, eventosIds);
  };

  const filterSelect = {
    correo: {
      label: "Correo",
      errorMessage: "Campo Requerido",
      fieldName: "correo",
      type: "text",
      defaultValue: "",
      required: true,
      regex: "",
      textSize: "h6",
    },

    perfil: {
      label: "Perfil",
      errorMessage: "Campo Requerido",
      fieldName: "perfil",
      type: "select",
      defaultValue: "inscriptor",
      required: true,
      regex: "",
      textSize: "h6",
      optionsArray: [
        {
          label: "Punto de Venta",
          value: "inscriptor",
        },
        {
          label: "Master Organizador",
          value: "MasterOrganizador",
        },
        {
          label: "Master Cliente",
          value: "MasterCliente",
        },
        {
          label: "Entrega de kits",
          value: "Kits",
        },
        {
          label: "Editor de Página Web",
          value: "Web",
        },
        {
          label: "Sin Acceso",
          value: "sinacceso",
        },
      ],
    },

    eventosIds: {
      label: "IDs de eventos separados por coma",
      errorMessage: "Campo Requerido",
      fieldName: "eventosIds",
      type: "text",
      defaultValue: "",
      required: true,
      regex: "",
      textSize: "h6",
    },
  };

  return (
    <Paper
      style={{
        margin: 5,
        padding: 20,
        minHeight: 320,
      }}
    >
      <Grid
        container
        direction="row"
        alignItems="center"
        spacing={2}
      >
        <Grid item xs={12}>
          <Typography
            gutterBottom
            variant="h4"
            component="h2"
          >
            Agregar usuarios autorizados
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body2">
            Ingresa los IDs de los eventos separados por coma.
            Ejemplo: 572, 573, 574, 580
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <FormRender
            callback={sendForm}
            formObject={filterSelect}
            submitButtonText="Autorizar"
          />
        </Grid>

        {(procesando || progreso.length > 0) && (
          <Grid item xs={12}>
            <Paper
              variant="outlined"
              style={{
                padding: 15,
                marginTop: 15,
              }}
            >
              <Grid
                container
                spacing={1}
                alignItems="center"
              >
                {procesando && (
                  <Grid item>
                    <CircularProgress size={22} />
                  </Grid>
                )}

                <Grid item>
                  <Typography variant="h6">
                    Progreso
                  </Typography>
                </Grid>
              </Grid>

              <div style={{ marginTop: 10 }}>
                {progreso.map((mensaje, index) => (
                  <Typography
                    key={index}
                    variant="body2"
                    style={{
                      marginBottom: 5,
                    }}
                  >
                    {mensaje}
                  </Typography>
                ))}
              </div>
            </Paper>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
}